import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18n from 'i18n-js';

const useStyles = makeStyles((theme) => {
  return {
    confirmList: {
      paddingLeft: 0,
      marginBottom: '0.75rem',
    },
  };
});

export const UnshareDisclaimer = ({ gracePeriod }) => {
  const hasGracePeriod = gracePeriod > 0;
  const listSize = hasGracePeriod ? 4 : 2;
  const key = hasGracePeriod
    ? 'bulk_unshare_confirm_with_grace'
    : 'bulk_unshare_confirm_with_no_grace';
  const classes = useStyles();

  return (
    <div>
      <ul className={classes.confirmList}>
        {[...Array(listSize).keys()].map((idx) => (
          <li
            key={idx}
            dangerouslySetInnerHTML={{
              __html: i18n.t(`vehicle.${key}.${idx}`, { gracePeriod }),
            }}
          />
        ))}
      </ul>
      <span>{i18n.t('vehicle.bulk_unshare_confirm_warning')}</span>
    </div>
  );
};
